
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Template } from "@/types";
import { useTranslation } from "react-i18next";

interface DeleteTemplateDialogProps {
  template: Template | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const DeleteTemplateDialog = ({
  template,
  open,
  onOpenChange,
  onConfirm,
}: DeleteTemplateDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('templates.delete_dialog.title')}</DialogTitle>
          <DialogDescription>
            {t('templates.delete_dialog.confirm', { name: template?.name })} {t('templates.delete_dialog.warning')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('templates.delete_dialog.cancel_btn')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
          >
            {t('templates.delete_dialog.delete_btn')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteTemplateDialog;
